import React from 'react';
import {
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
} from '@material-ui/core';


const RequestPromotionExclusions = ({
  values,
  handleChange,
  handleBlur,
  touched,
  errors
}) => {
  return (
    <Card className="p-5 mt-4" elevation={0}>
      <Typography variant="h5" className="font-bold mb-2">
        Exclusions
      </Typography>
      <Typography variant="h5" className="mb-5 font-medium text-gray">
        Write down any exclusions or limits applicable to this special.
      </Typography>
      <FormControl component="fieldset" className="w-full">
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                name="exclusionNotes.exclusions.checked"
                checked={values.exclusionNotes?.exclusions.checked}
                onChange={handleChange}
              />}
            label={values.exclusionNotes?.exclusions.name}
          />
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                name="exclusionNotes.consultationRequired.checked"
                checked={values.exclusionNotes?.consultationRequired.checked}
                onChange={handleChange}
              />}
            label={values.exclusionNotes?.consultationRequired.name}
          />
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                name="exclusionNotes.cantCombineWithOffer.checked"
                checked={values.exclusionNotes?.cantCombineWithOffer.checked}
                onChange={handleChange}
              />}
            label={values.exclusionNotes?.cantCombineWithOffer.name}
          />
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                name="exclusionNotes.noReturns.checked"
                checked={values.exclusionNotes?.noReturns.checked}
                onChange={handleChange}
              />}
            label={values.exclusionNotes?.noReturns.name}
          />
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                name="exclusionNotes.onlineOnly.checked"
                checked={values.exclusionNotes?.onlineOnly.checked}
                onChange={handleChange}
              />}
            label={values.exclusionNotes?.onlineOnly.name}
          />
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                name="exclusionNotes.suppliesLast.checked"
                checked={values.exclusionNotes?.suppliesLast.checked}
                onChange={handleChange}
              />}
            label={values.exclusionNotes?.suppliesLast.name}
          />
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                name="exclusionNotes.other.checked"
                checked={values.exclusionNotes?.other.checked}
                onChange={handleChange}
              />}
            label={values.exclusionNotes?.other.name}
          />
          {values.exclusionNotes?.other.checked &&
          <TextField
            fullWidth
            value={values.exclusionNotes?.other.value}
            name="exclusionNotes.other.value"
            multiline
            rows={4}
            variant="outlined"
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.exclusionNotes?.other.value && Boolean(errors.exclusionNotes?.other.value)}
            helperText={touched.exclusionNotes?.other.value && errors.exclusionNotes?.other.value}
          />
          }
        </FormGroup>
      </FormControl>
    </Card>
  );
};

export default RequestPromotionExclusions;
